import api from '@/api/api.js'

// 用户相关API接口
const userAPI = {
  // 用户登录
  // 请求参数: {userName: string, password: string}
  // 返回格式: {code: number, msg: string, data: {userId: number, userToken: string}}
  login: (data) => {
    return api.post('/login', data)
  },
  
  // 用户登出
  // 请求参数: {token: string}
  // 返回格式: {code: number, msg: string, data: object}
  logout: (token) => {
    return api.post('/logout', { token })
  },
  
  // 获取用户信息
  getUserInfo: () => {
    return api.get('/user/info')
  }
}

// 导出API
export default userAPI